<app-entity-list
  title="Міста"
  [columns]="columns"
  [data]="cities$ | async"
  [totalItems]="totalItems$ | async"
  [pageSize]="pageSize$ | async"
  [pageIndex]="pageIndex$ | async"
  [loading]="loading"
  [customRowActions]="customRowActions"
  [endRowActions]="endRowActions"
  [showDelete]="showDelete"
  [rowClass]="rowClass"
  (pageChange)="onPageChange($event)"
  (sortChange)="onSortChange($event)"
  (searchChange)="onSearch($event)"
  (action)="onAction($event)"
>
  <div appFilters class="cities-filters">
    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>Країна</mat-label>
      <mat-select [formControl]="countryFilter" (selectionChange)="onCountryFilter($event.value)">
        <mat-option [value]="null">Всі країни</mat-option>
        @for (country of countries$ | async; track country.id) {
          <mat-option [value]="country.id">{{ country.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>Регіон</mat-label>
      <mat-select [formControl]="regionFilter" (selectionChange)="onRegionFilter($event.value)">
        <mat-option [value]="null">Всі регіони</mat-option>
        @for (region of filteredRegions$ | async; track region.id) {
          <mat-option [value]="region.id">{{ region.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <div class="filter-toggles">
      <mat-checkbox (change)="onShowEmptyCitiesChange($event.checked)">Пусті міста</mat-checkbox>
      <mat-checkbox (change)="onShowDuplicatesChange($event.checked)">Дублікати</mat-checkbox>
      <mat-checkbox (change)="onShowWithoutRegionChange($event.checked)">Без регіону</mat-checkbox>
    </div>
  </div>
</app-entity-list>
